import styled, { css } from 'styled-components';

interface ContainerProps {
  removeTopMargin?: boolean;
}

export const IframeContainer = styled.div<ContainerProps>`
  box-sizing: border-box;
  width: 100%;
  max-width: ${({ theme }) => theme.sizes?.maxBodyWidth};
  padding: 0rem 0rem;
  ${({ removeTopMargin }: ContainerProps) =>
    removeTopMargin
      ? css`
          margin: -8rem auto 0 auto;
        `
      : css`
          margin: 0 auto;
        `};
  position: relative;
  @media (max-width: ${({ theme }) => theme.devices.tablet.max}) {
    ${({ removeTopMargin }: ContainerProps) =>
      !removeTopMargin &&
      css`
        padding: 3rem 4rem;
      `};
  }
  @media (max-width: ${({ theme }) => theme.devices.mobile.max}) {
    ${({ removeTopMargin }: ContainerProps) =>
      removeTopMargin
        ? css`
            margin: -3rem auto 0 auto;
          `
        : css`
            padding: 1rem;
          `};
  }
`;
